var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElementPlusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 16.75V17.25H18.25H20.5C20.6339 17.25 20.75 17.3661 20.75 17.5C20.75 17.6339 20.6339 17.75 20.5 17.75H18.25H17.75V18.25V20.5C17.75 20.6339 17.6339 20.75 17.5 20.75C17.3661 20.75 17.25 20.6339 17.25 20.5V18.25V17.75H16.75H14.5C14.3661 17.75 14.25 17.6339 14.25 17.5C14.25 17.3661 14.3661 17.25 14.5 17.25H16.75H17.25V16.75V14.5C17.25 14.3661 17.3661 14.25 17.5 14.25C17.6339 14.25 17.75 14.3661 17.75 14.5V16.75Z",
    fill: "#27548C",
    stroke: "#27548C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7731 9.99001V9.99H19.77H15.73C14.9723 9.99 14.5694 9.85211 14.3501 9.65808C14.1466 9.47796 14 9.15669 14 8.51V3.98C14 3.33935 14.1461 3.01693 14.3509 2.83503C14.5707 2.63973 14.974 2.5 15.73 2.5H19.77C20.526 2.5 20.9293 2.63973 21.1491 2.83503C21.3539 3.01693 21.5 3.33935 21.5 3.98V8.52C21.5 9.16102 21.3537 9.48268 21.1499 9.66308C20.9312 9.85664 20.5288 9.99476 19.7731 9.99001Z",
    fill: "#27548C",
    stroke: "#27548C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z",
    fill: "#27548C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z",
    fill: "#27548C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementPlusActive);
export default __webpack_public_path__ + "static/media/element-plus-active.801016d0b6c1132028a2d9f2ca84026c.svg";
export { ForwardRef as ReactComponent };